import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

const NEXT = [
  ["Within 24 hours", "A trade desk specialist confirms receipt and any clarifications."],
  ["Within 3 working days", "Indicative offer: grades, availability, pricing basis and shipping windows."],
  ["On request", "Pre-shipment samples for cupping, cut-test or lab analysis."]
];

export default function Confirmation({ reference, onReset }) {
  return (
    <div className="text-center max-w-2xl mx-auto py-6" data-testid="wholesale-confirmation">
      <span className="mx-auto h-16 w-16 rounded-full bg-[#1f4a33] text-[#f6f1e7] flex items-center justify-center"><Check size={28} /></span>
      <p className="mt-8 text-[#7c5230] text-xs tracking-[0.25em] uppercase">Enquiry received</p>
      <h2 className="mt-4 font-display text-4xl md:text-6xl font-light leading-[1.02] text-[#10271a]">
        Thank you. <em className="italic text-[#1f4a33]">We're on it.</em>
      </h2>
      <p className="mt-5 text-[#5e6b61] text-lg">
        Your reference is <span className="font-semibold text-[#10271a] tabular-nums" data-testid="wholesale-reference">{reference}</span>. Keep it handy for any follow-up.
      </p>
      <ul className="mt-10 text-left divide-y divide-[#10271a]/10 rounded-3xl border border-[#10271a]/10 bg-[#fbf8f1]">
        {NEXT.map(([when, what]) => (
          <li key={when} className="px-6 py-5 grid grid-cols-1 sm:grid-cols-[180px_1fr] gap-1 sm:gap-6">
            <span className="text-[11px] tracking-[0.18em] uppercase text-[#7c5230] pt-1">{when}</span>
            <span className="text-[#10271a]">{what}</span>
          </li>
        ))}
      </ul>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
        <Link to="/trading/coffee" className="group inline-flex items-center gap-3 bg-[#1f4a33] text-[#f6f1e7] px-7 py-4 rounded-full text-sm tracking-[0.12em] uppercase font-semibold hover:bg-[#10271a] transition-colors" data-testid="confirmation-back-link">
          Back to the journey
          <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
        </Link>
        <button type="button" onClick={onReset} className="text-sm tracking-[0.12em] uppercase font-semibold text-[#1f4a33] border-b-2 border-[#1f4a33]/30 pb-1 hover:border-[#1f4a33] transition-colors" data-testid="confirmation-new-enquiry">
          Start another enquiry
        </button>
      </div>
    </div>
  );
}
